import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  cardCheckoutData: null,
};

export const getCardCheckoutApi = createAsyncThunk(
  "cardCheckoutapi/getCardCheckoutApi",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(`checkout-pay`, params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Asks the backend to create a Checkout.com PaymentSession for the order. The
// response carries `payment_session`, `public_key` and `environment`, which
// the Flow SDK mounts against.
export const getCheckoutPaymentSession = createAsyncThunk(
  "cardCheckoutapi/getCheckoutPaymentSession",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(`checkout-payment-session`, params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getCardStatus = createAsyncThunk(
  "cardCheckoutapi/getCardStatus",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(`checkout-payment-status`, params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const cardApisSlice = createSlice({
  name: "cardCheckoutapi",
  initialState,
  reducers: {},
  extraReducers: {
    [getCardCheckoutApi.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getCardCheckoutApi.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.cardCheckoutData = action.payload?.data;
    },
    [getCardCheckoutApi.rejected]: (state, action) => {
      state.status = "failed";
    },

    [getCardStatus.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getCardStatus.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.cardCheckoutData = action.payload?.data;
    },
    [getCardStatus.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default cardApisSlice.reducer;
